import clsx from 'clsx'
import React, { FC, ReactNode } from 'react'

import { useWishList } from '@Domains/WishList/Hooks'

import styles from './WishList.module.scss'

interface UnWishedWrapperProps {
  children?: ReactNode
  id: string
}

export const UnWishedWrapper: FC<UnWishedWrapperProps> = ({ children, id }) => {
  const [isWishedFor] = useWishList(id)

  return (
    <div className={clsx(!isWishedFor && styles.unWished)}>
      {children}
    </div>
  )
}
